import "./index.scss";

export const AboutMe = () => (
  <section className="flex flex-col py-8 items-center justify-center">
    <div className="about_me">

    </div>
  </section>
);
